module.exports = __webpack_public_path__ + "img/featurefour2.1f41a089.png";